var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReportSection',{attrs:{"columns":1,"data-test-id":"ValueReport_vendorConsolidationCard","title":"Vendor Consolidation"}},[_c('PricingComparison',{attrs:{"planMonthlyPrice":_vm.pricePerUser,"planName":_vm.planName,"productCode":_vm.productCode,"showTagline":true,"usersCount":_vm.usersCount}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }